import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { ExclamationLine24 } from 'seagull/icons';
import { useTestIds } from 'seagull/utils/TestIds';
import { getRowErrorMessage, getGlobalErrorMessage } from "../BulkBillingModal.utils";
import styles from "./ValidationErrors.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ValidationErrors = _ref => {
  let {
    errors
  } = _ref;
  const {
    ValidationErrorsTestIds
  } = useTestIds();
  const errorMessages = useMemo(() => {
    var _errors$globalErrors, _errors$rowErrors;
    return [...(((_errors$globalErrors = errors.globalErrors) === null || _errors$globalErrors === void 0 ? void 0 : _errors$globalErrors.map(error => getGlobalErrorMessage(error))) || []), ...(((_errors$rowErrors = errors.rowErrors) === null || _errors$rowErrors === void 0 ? void 0 : _errors$rowErrors.map(error => getRowErrorMessage(error))) || [])];
  }, [errors]);
  return /*#__PURE__*/_jsxs(Box, {
    "data-testid": ValidationErrorsTestIds.Container(),
    className: styles.validationErrors,
    children: [/*#__PURE__*/_jsxs(Box, {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(ExclamationLine24, {}), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        children: "List can't be imported"
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: styles.errorsContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        children: "Details:"
      }), /*#__PURE__*/_jsx("ul", {
        className: styles.errorsContentErrors,
        children: errorMessages.map((message, index) => /*#__PURE__*/_jsx("li", {
          "data-testid": ValidationErrorsTestIds.Error(index),
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph2",
            children: message
          })
        }, index))
      })]
    })]
  });
};